// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__3LxvM","spin":"Loader_spin__kWkUn","loadsuccess":"Loader_loadsuccess__HvOXB","loaderror":"Loader_loaderror__K7Dji","mini":"Loader_mini__OIgfV"};